<script>
    import Post from "./Post.svelte";
</script>

<div class="Main-Text">
    <div class="Article-Head">
        <div class="Heading">
            <div class="Headline"><h1>Programming</h1></div>

            <div class="Datum">Learning JavaScript, Python</div>
        </div>
    </div>
    <p>
        At the beginning of 2020, I decided, that I needed to fill my newly won
        free time with something meaningful. One thing on my bucket list has
        always been programming. I spent 2020 to start studying JavaScript.
        <br />
        <br />
        I switched to Python in 2021 because I realized web development was not my
        main interest but working with data was. I worked on several Discord bots
        for my community and further small projects. In late 2021 I went back to
        JavaScript by learning Svelte.
        <br />
        <br />
        You can read about my programming journey on
        <a href="http://blog.tiia.rocks" target="_blank">Tiias Tech Blog</a> [External
        Link].
    </p>
    <hr />
    <div class="Article-Head">
        <div class="Heading">
            <div class="Headline"><h1>YouTube</h1></div>
            <div class="Datum">German and English channel about ARK</div>
        </div>
    </div>
    <p>
        <img
            class="Dino"
            src="./Fabulous.png"
            alt="brown dinosaur with with the word fabulous written above it"
        />I create <b>educational</b> and entertaining content about the game
        ARK: Survival Evolved, helping to teach people who want to master
        endgame mechanics which are often hidden behind community gatekeeping.
        My goal is to empower people to reach their goals.
        <br /><br />
        I create content in German and English on two different channels. You find
        them here:
        <a
            href="https://www.youtube.com/channel/UC1yWB1LmHaKn4_hS9Fozzkg"
            target="_blank"
        >
            English YouTube Channel</a
        >
        ||
        <a
            href="https://www.youtube.com/channel/UCnrafnvV_ZO_Xt2k5s678kw"
            target="_blank"
        >
            German YouTube Channel</a
        ><br /> [External Links]
    </p>
    <hr />
    <div class="Article-Head">
        <div class="Heading">
            <div class="Headline"><h1>Streaming</h1></div>

            <div class="Datum">Live Streaming on Twitch</div>
        </div>
    </div>
    <p>
        Beware! I don't stream super regular, but I love to hang out with the
        community in the evenings. I do stream on English on my main channel and
        German on my secondary channel.
        <br />
        <br />
        I don't only stream ARK, but also other games that I feel like playing. Sometimes
        we even just have "Just Talking" streams in which we talk about daily things
        and events. Since my main focus is on YouTube, Streaming only happens when
        I do have enough free time for it. If you want to visit my channels, check
        these links:
        <a href="http://twitch.tv/TiiaAurora" target="_blank"
            >Twitch English (main)</a
        >
        , and
        <a href="http://twitch.tv/TiiaAuroraDE" target="_blank"
            >Twitch German (secondary)</a
        >.
        <br />
    </p>
</div>

<style>
    div.Article-Head {
        display: flex;
        justify-content: stretch;
        flex-direction: column;
    }

    div.Heading {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }

    div.Datum {
        text-align: right;
        padding-top: 15px;
        font-weight: bolder;
    }

    div.Main-Text {
        font-family: "Raleway", sans-serif;
        font-size: 14px;
        line-height: 16pt;
        text-align: left;
        background-color: #222;
        padding: 25px;
    }
    div.Main-Text h1 {
        color: rgb(233, 107, 24);
        text-shadow: 3px 3px 8px black;
        font-family: "IM Fell English SC", serif;
    }

    div.Main-Text a {
        color: rgb(233, 107, 24);
    }

    img {
        width: 150px;

        float: left;
        padding-right: 20px;
        padding-top: -10px;
    }
</style>
